export default (props) => {
  const { color, width, height } = props;
  const colorInput = color || "#2A63F6";
  const widthInput = width || 16;
  const heightInput = height || 16;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={widthInput}
      height={heightInput}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.76368 5.35988C7.84709 5.35988 7.9305 5.33208 8.0139 5.33208C9.4874 5.33208 10.6829 6.52756 10.6829 8.00107C10.6829 9.47457 9.4874 10.67 8.0139 10.67C6.5126 10.67 5.34492 9.47457 5.34492 8.00107C5.34492 7.94546 5.34492 7.86206 5.34492 7.77865C5.59513 7.91766 5.90096 8.00107 6.23458 8.00107C7.20765 8.00107 8.0139 7.22261 8.0139 6.22174C8.0139 5.91592 7.90269 5.6101 7.76368 5.35988ZM13.3519 4.02539C14.6586 5.22087 15.5204 6.66657 15.9374 7.66744C16.0209 7.88986 16.0209 8.14008 15.9374 8.36249C15.5204 9.33556 14.6586 10.7813 13.3519 12.0045C12.0452 13.2278 10.2381 14.2287 8.0139 14.2287C5.76195 14.2287 3.95482 13.2278 2.64813 12.0045C1.34144 10.7813 0.479583 9.33556 0.0625543 8.36249C-0.0208514 8.14008 -0.0208514 7.88986 0.0625543 7.66744C0.479583 6.66657 1.34144 5.22087 2.64813 4.02539C3.95482 2.80211 5.76195 1.77344 8.0139 1.77344C10.2381 1.77344 12.0452 2.80211 13.3519 4.02539ZM8.0139 3.99759C5.78975 3.99759 4.01043 5.80471 4.01043 8.00107C4.01043 10.2252 5.78975 12.0045 8.0139 12.0045C10.2103 12.0045 12.0174 10.2252 12.0174 8.00107C12.0174 5.80471 10.2103 3.99759 8.0139 3.99759Z"
        fill={colorInput}
      />
    </svg>
  );
};
